<template>
  <v-form>
    <v-row>
      <div class="inputSearch">
        <v-row>
          <v-col cols="12" md="4" lg="4">
            <v-text-field v-model="titleFilter" v-bind:label="$route.meta.title" hide-details outlined required dense />
          </v-col>
          <v-col cols="12" md="4" lg="4" v-if="router !== 'main'">
            <v-autocomplete
              v-model="appliedHeadFilter"
              clear-icon="mdi-close"
              :items="listAppliedHeads"
              item-text="title"
              item-value="id"
              label="Áp dụng với thành phần lương"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4" lg="4" v-if="router === 'main'">
            <v-autocomplete
              v-model="defaultFilter"
              clear-icon="mdi-close"
              :items="[
                { title: 'Mặc định', value: 'default' },
                { title: 'Bổ sung', value: 'custom' }
              ]"
              item-text="title"
              item-value="value"
              label="Phân loại"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4" lg="4" v-if="router === 'adjust'">
            <v-autocomplete
              v-model="typeFilter"
              clear-icon="mdi-close"
              :items="[
                { title: 'Thưởng', value: 'sum' },
                { title: 'Phạt', value: 'sub' }
              ]"
              item-text="title"
              item-value="value"
              label="Phân loại"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </div>
      <div class="buttonSearch ml-6">
        <div class="d-flex flex-column justify-start">
          <v-btn class="search-button" @click="onFilterChange" outlined>
            Tìm kiếm
          </v-btn>
        </div>
      </div>
    </v-row>
  </v-form>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import unidecode from 'unidecode'

export default {
  data: () => ({
    titleFilter: null,
    typeFilter: null,
    appliedHeadFilter: null,
    listAppliedHeads: [],
    defaultFilter: null
  }),
  computed: {
    ...mapState('salaryHead', ['router', 'createdSalaryHead'])
  },
  async created() {
    this.listAppliedHeads = await this.fetchHeadsIndependent({ category: 'main' })
  },
  methods: {
    ...mapActions({
      fetchHeadsIndependent: 'salaryHead/fetchHeadsIndependent',
      saveHeadFilters: 'salaryHead/filterheadFee'
    }),
    onFilterChange() {
      let payload = {
        tags_contains: this.titleFilter && unidecode(this.titleFilter),
        category: this.router,
        head_fee_apply: this.appliedHeadFilter,
        defaultFilter: this.defaultFilter
      }
      if (this.router !== 'main') payload.type = this.typeFilter
      this.saveHeadFilters(payload)
    },
    onHeadAddedSuccess() {
      if (this.router === 'main') {
        this.titleFilter = this.createdSalaryHead.tags
      } else {
        this.titleFilter = this.createdSalaryHead.tags
        this.appliedHeadFilter = this.createdSalaryHead.head_fee_apply
      }
    }
  },
  watch: {
    router: {
      async handler(val) {
        if (val !== 'main') this.listAppliedHeads = await this.fetchHeadsIndependent({ type: val })
      },
      immediate: true,
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
div.buttonSearch {
  width: 106px;
}

div.inputSearch {
  width: calc(100% - 120px - 12px);
}

@media screen and (max-width: 960px) {
  div.buttonSearch {
    width: 110px;
    padding-top: 24px;
    margin-left: 0px !important;
  }

  div.inputSearch {
    width: 100%;
  }
}
</style>
